// TODO: Scroll down to map after filter change
// TODO: Should bounds of map be reset after filtering?

import { updateUrl, getFilterVals, getView } from "./filtered-events-list";

const htmlEl = document.documentElement;
let allMarkers = [];

const mapsScriptLoadedClass = "maps-script-loaded";
function handleGMapsLoaded() {
	document.documentElement.classList.add(mapsScriptLoadedClass);
}

const init = () => {
	htmlEl.addEventListener("filter-change", (e) => {
		// Don't automatically get events when "pick-a-date" chosen. Need to wait for selected date event.
		if (e.detail !== "pick-a-date") {
			filterMarkers();
		}
	});

	// Listen for when specific date chosen
	htmlEl.addEventListener("date-chosen", function (e) {
		filterMarkers();
	});

	// Listen for when specific date closed
	htmlEl.addEventListener("date-closed", function (e) {
		filterMarkers();
	});

	// Create MutationObserver to monitor class changes on html
	const mo = new MutationObserver(handleHtmlClassMutation);
	mo.observe(htmlEl, {
		attributes: true,
		attributeFilter: ["class"],
	});

	// Create Intersection Observer to track when maps are visible
	const io = new IntersectionObserver(handleIntersectionChange);

	// Loop through map elements
	for (const m of document.querySelectorAll("[data-map]")) {
		// Watch map with IntersectionObserver
		io.observe(m);
	}
};

const filterMarkers = async () => {
	const filtersContainer = document.querySelector("[data-filtered-events-list]");
	const currFilters = getFilterVals(filtersContainer);
	const currView = getView(filtersContainer);

	console.log(currFilters);

	// Fetch date range data if date filter is set
	let dateRangeData = null;
	if (currFilters.date) {
		try {
			const params = new URLSearchParams({
				"filter-value": currFilters.date,
			});
			const response = await fetch(`/actions/events-module/default/get-date-range?${params}`);
			dateRangeData = await response.json();

			// Only run filtering after fetch completes
			let numShowing = 0;
			for (const marker of allMarkers) {
				let shouldShow = true;

				// Check if marker event date is within the date range
				if (dateRangeData && dateRangeData.length === 2) {
					const markerDate = new Date(marker.eventDate);
					const startDate = new Date(dateRangeData[0]);
					const endDate = new Date(dateRangeData[1]);

					if (markerDate < startDate || markerDate > endDate) {
						shouldShow = false;
					}
				}

				// Check if marker categories match selected category
				if (currFilters.category !== "all" && !marker.categories.some((cat) => cat.slug === currFilters.category)) {
					shouldShow = false;
				}

				// For AdvancedMarkerElement, use the map property
				// Store the original map reference if not already stored
				if (!marker.originalMap) {
					marker.originalMap = marker.map;
				}

				marker.map = shouldShow ? marker.originalMap : null;
				if (shouldShow) {
					numShowing++;
				}

				filtersContainer.querySelector("[data-events-view-switcher-total]").innerHTML = numShowing;
			}

			console.log(currFilters);

			updateUrl(currFilters, currView);
		} catch (error) {
			console.error("Error fetching date range:", error);
		}
	}
};

const handleHtmlClassMutation = (mutationsList) => {
	// For each observed mutation
	mutationsList.forEach((mutation) => {
		// Get mutation target
		const el = mutation.target;

		// If it contains the class that shows the maps script has loaded
		if (el.classList.contains(mapsScriptLoadedClass)) {
			for (const m of document.querySelectorAll("[data-map-loading]")) {
				loadMap(m);
			}
		}
	});
};

// Handles when intersection changes on map elements
const handleIntersectionChange = (entries) => {
	// For each map element
	entries.forEach((entry) => {
		// If element is intersecting (i.e. is visible)
		if (entry.isIntersecting) {
			// Load map
			loadMap(entry.target);
		}
	});
};

const loadMap = (el) => {
	// If Google Maps script not yet available...
	if (typeof google !== "object" || typeof google.maps !== "object") {
		// Add attribute to map element to show that it's currently in process of loading.
		// This is used to target map once Google script loaded
		el.setAttribute("data-map-loading", "");

		// Create script tag to load it
		const s = document.createElement("script");
		s.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=" + googleMapsApiKey + "&libraries=marker&callback=handleGMapsLoaded");
		htmlEl.appendChild(s);

		return false;
	}

	// Check if map already loaded
	if (el.hasAttribute("data-map-loaded") === false) {
		// Get ID of map
		const mapId = el.getAttribute("data-map");

		// Create map
		const map = new google.maps.Map(el, {
			mapId: mapId,
			center: {
				lat: 0,
				lng: 0,
			},
			styles: [
				{
					featureType: "poi.business",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
			],
		});

		const infoWindow = new google.maps.InfoWindow({});

		// Check if origin coords supplied
		if (el.hasAttribute("data-map-origin")) {
			// Separate origin coords into array
			const arrOrigin = el.getAttribute("data-map-origin").split(",");

			// Attach marker to map
			const marker = new google.maps.marker.AdvancedMarkerElement({
				map,
				position: {
					lat: parseFloat(arrOrigin[0]),
					lng: parseFloat(arrOrigin[1]),
				},
				title: "Your location",
				gmpClickable: true,
			});
		}

		map.addListener("bounds_changed", () => {
			// If map not yet set as 'loaded'
			if (el.hasAttribute("data-map-loaded") === false) {
				// Get map zoom level
				const z = map.getZoom();

				// If zoomed in too far initially, set to sensible level
				if (z > 17) {
					map.setZoom(17);
				}

				// Remove 'loading' attr and add 'loaded' attr
				el.removeAttribute("data-map-loading");
				el.setAttribute("data-map-loaded", "");
			}
		});

		// Check for any map data
		if (typeof mapData !== undefined) {
			// Try to find marker data in mapData based on id
			const markersData = mapData.find(({ id }) => id === mapId);

			// If marker data found...
			if (markersData !== undefined) {
				// Create bounds object
				let bounds = new google.maps.LatLngBounds();

				// Loop through marker data
				for (const markerData of markersData.markers) {
					// Define marker position
					const markerPos = {
						lat: parseFloat(markerData.lat),
						lng: parseFloat(markerData.lng),
					};

					// Attach marker to map
					const marker = new google.maps.marker.AdvancedMarkerElement({
						map,
						position: markerPos,
						anchorLeft: "-50%",
						anchorTop: "-50%",
						content: buildMarkerContent(markerData),
					});

					// Attach custom data to the marker for filtering
					marker.eventDate = markerData.eventDate;
					marker.categories = markerData.categories;
					marker.name = markerData.name;
					marker.venue = markerData.venue;

					// Add marker to array
					allMarkers.push(marker);

					marker.addListener("click", (event) => {
						// Check if the click was on a link or button
						const clickedElement = event.domEvent && event.domEvent.target;
						if (clickedElement && (clickedElement.tagName === "A" || clickedElement.tagName === "BUTTON" || clickedElement.closest("a") || clickedElement.closest("button"))) {
							// Let the link/button handle the click naturally

							if (clickedElement.closest("button") && clickedElement.closest("button").ariaLabel === "Close") {
								toggleHighlight(marker);
							}

							return;
						}

						toggleHighlight(marker);
						map.panTo(marker.position);
						// Offset the marker lower than center to account for marker popup info (negative Y moves marker down visually)
						map.panBy(0, -150);
					});

					// Extend bounds based on marker position
					bounds.extend(markerPos);
				}

				// Fit map to all markers
				map.fitBounds(bounds, 100);

				// Filter the markers based on current filters
				filterMarkers();
			}
		}
	}
};

const formatEventDate = (dateString) => {
	const date = new Date(dateString);
	const day = date.getDate();
	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	const month = monthNames[date.getMonth()];
	const year = date.getFullYear();

	// Add ordinal suffix (st, nd, rd, th)
	const suffix = (day) => {
		if (day > 3 && day < 21) return "th";
		switch (day % 10) {
			case 1:
				return "st";
			case 2:
				return "nd";
			case 3:
				return "rd";
			default:
				return "th";
		}
	};

	return `${day}${suffix(day)} ${month} ${year}`;
};

const buildMarkerContent = (markerData) => {
	const content = document.createElement("div");
	content.classList.add("map-marker");

	let catItemsHTML = "";
	for (const cat of markerData.categories) {
		catItemsHTML += `<li class="tag-list__item">
			<span class="category-tag" style="background-color: ${cat.color}">${cat.name}</span></li>`;
	}

	content.innerHTML = `
    <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" width="35" height="35"><circle fill="#f0001a" cx="17.5" cy="17.5" r="17.5"/><path fill="#fff" d="M15.57,23.13,14.1,16.26H14l-1.44,6.87h-4L6,11.87H9.75l1.31,6.38h.06l1.28-6.38H16l1.38,6.38h.06l1.18-6.38h3.6L19.56,23.13Z"/><polygon points="25.45 11.87 24.04 17.89 22.83 23.13 26.4 23.13 29.02 11.87 25.45 11.87"/></svg>
    </div>
    <div class="details">
		<ul class="tag-list">${catItemsHTML}</ul>

		<h3 class="heading">${markerData.name}</h3>
		<ul class="meta">
        	<li>${formatEventDate(markerData.eventDate)}</li>
        	<li>${markerData.venue}</li>
			<li><a href="${markerData.url}">View Event Details</a></li>
			<li><a href="https://maps.google.com/?q=${markerData.lat},${markerData.lng}" rel="noopener noreferrer" target="_blank">Get Directions</a></li>
		</ul>
		<button aria-label="Close">X</button>
    </div>
    `;
	return content;
};
const toggleHighlight = (marker) => {
	// First, remove highlight from all markers
	allMarkers.forEach((m) => {
		if (m !== marker && m.content.classList.contains("highlight")) {
			m.content.classList.remove("highlight");
			m.zIndex = null;
		}
	});

	// Then add/toggle highlight on the clicked marker
	if (marker.content.classList.contains("highlight")) {
		marker.content.classList.remove("highlight");
		marker.zIndex = null;
	} else {
		marker.content.classList.add("highlight");
		marker.zIndex = 1;
	}
};

export default init;
